import React, { Component } from 'react';
import {
    Paper,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    CircularProgress
} from '@material-ui/core';

import { withTheme } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import withUser from '../HOC/HOCwithUser.jsx';
import moment from 'moment';
import { validatePromoCode } from '../../utils/validators/validateForm.js';
import { NotificationManager } from 'react-notifications';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
class PromocodePanel extends Component {
    constructor() {
        super();
        this.state = {
            checked: true,
            appliedPromocode: '',
            promoApplied: false
        };
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    renderButton = code => {
        return (
            <Button
                variant="contained"
                style={{
                    backgroundColor: this.props.theme.palette.primary.main,
                    color: '#ffffff',
                    fontSize: '16px'
                }}
                size="large"
                onClick={() => this.applyPromoCode(code)}
                disabled={this.state.loader}
            >
                <FormattedMessage id="promo.apply" defaultMessage="Apply" />
            </Button>
        );
    };
    handleError = params => {
        this.setState(params);
    };
    applyPromoCode = code => {
        this.setState({ loader: true, appliedPromocode: code });
        this.props.checkPromoCodeAction(
            {
                promoCode: code.code,
                packageSelected: this.props.packageItem
                    ? [this.props.packageItem.key]
                    : []
            },
            this.onDone
        );
    };
    onDone = (success, data) => {
        if (success) {
            this.setState({
                loader: false,
                promoApplied: true
            });
            NotificationManager.success(data.message, 'Success');
            if (this.props.packageItem) {
                this.props.promoCodeApplied(
                    this.state.appliedPromocode,
                    data.data.amount
                );
            } else {
                this.props.promoCodeApplied(this.state.appliedPromocode);
            }
        } else {
            this.setState({ loader: false });
            NotificationManager.error(data.message, 'Error');
            // this.handleClose();
        }
    };

    removePromoCode = () => {
        this.setState({ appliedPromocode: '', promoApplied: false }, () => {
            this.props.promoCodeApplied('');
        });
    };
    render() {
        const { data } = this.props;

        if (this.state.loader) {
            return (
                <div className=" text-center" style={{ minHeight: 200 }}>
                    <CircularProgress />
                </div>
            );
        }
        if (this.state.promoApplied) {
            return (
                <div className="col-md-12">
                    <div className="my-4">
                        <h4>
                            <FormattedMessage
                                id="promo.couponcode"
                                defaultMessage="Coupon Code Applied"
                            />
                        </h4>
                        <b>{this.state.appliedPromocode.code}</b>
                        <div className="sign-new-btn nt-3">
                            <Button
                                variant="outlined"
                                onClick={this.removePromoCode}
                            >
                                <FormattedMessage
                                    id="promo.remove"
                                    defaultMessage="Remove"
                                />
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div className="col-md-12">
                <div className="my-4">
                    <h4>
                        <FormattedMessage
                            id="promo.heading"
                            defaultMessage="Coupon Code"
                        />
                    </h4>
                    <p>
                        <FormattedMessage
                            id="promo.description"
                            defaultMessage="Have a promocode? Add here"
                        />
                    </p>
                    <div className="sign-new-btn">
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={this.props.renderPromoPopup}
                        >
                            <FormattedMessage
                                id="promo.add"
                                defaultMessage="Add Your Own"
                            />
                        </Button>
                    </div>
                </div>
                {data.length > 0 && (
                    <div className="my-4">
                        <h4>
                            <FormattedMessage
                                id="promo.currentoffers"
                                defaultMessage="Current Offers"
                            />
                        </h4>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        <FormattedMessage
                                            id="promo.code"
                                            defaultMessage="Code"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <FormattedMessage
                                            id="promo.desc"
                                            defaultMessage="Description"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <FormattedMessage
                                            id="promo.expiredon"
                                            defaultMessage="Expired On"
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <FormattedMessage
                                            id="promo.getitnow"
                                            defaultMessage="Get it Now"
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map(code => {
                                    return (
                                        <TableRow key={code.key}>
                                            <TableCell>
                                                <b>{code.code}</b>
                                            </TableCell>
                                            <TableCell>
                                                {code.description}
                                            </TableCell>
                                            <TableCell>
                                                {moment(code.end_date).format(
                                                    'DD-MMM-Y'
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {this.renderButton(code)}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </div>
                )}
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(
        null,
        actions
    )
);
export default composedHOC(PromocodePanel);



// WEBPACK FOOTER //
// ./src/components/Booking/PromocodePanel.jsx